// src/keycloak.ts
import Keycloak from 'keycloak-js';

export const KEYCLOAK_URL =
  process.env.VUE_APP_KEYCLOAK_URL || 'http://localhost:8083';

// Initialize Keycloak instance
const keycloak = new Keycloak({
  url: KEYCLOAK_URL,
  realm: process.env.VUE_APP_KEYCLOAK_REALM,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
});

// Export the instance for use in other files
export default keycloak;

export function login() {
  keycloak.login();
}

export function logout() {
  keycloak.logout({ redirectUri: window.location.origin });
}
